import { type FluxStore } from './Store';

// Toasts
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

// Login
export const SET_UPDATE_REQUIRED = 'SET_UPDATE_REQUIRED';
// das Token für die Kommunikation (nach dem Login vorhanden)
export const SET_LOGIN_TOKEN = 'LOGIN_TOKEN';
// Websocket-Connection
export const SET_IMAGESETTINGS = 'SET_IMAGESETTINGS';
export const SET_UNCHANGED_DATA = 'SET_UNCHANGED_DATA';

// Dashboard
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';

// Leads
export const SET_LAST_LEAD_LIST_UPDATE = 'SET_LAST_LEAD_LIST_UPDATE';
export const SET_LEADSTATUS = 'SET_LEADSTATUS';
export const SET_LEAD_SUCHE = 'SET_LEAD_SUCHE';

// Fahrzeuge
export const SET_ALLVEHICLESSTATE = 'SET_ALLVEHICLESSTATE';
export const SET_CARLIST = 'SET_CARLIST';
export const SET_CARLIST_FILTER = 'SET_CARLIST_FILTER';
export const SET_CARLIST_FILTERED = 'SET_CARLIST_FILTERED';
export const SET_CARLIST_SIZE = 'SET_CARLIST_SIZE';
export const SET_CHANGED_CARS = 'SET_CHANGED_CARS';
export const SET_AKT_SUPPORT_FIRMA = 'SET_AKT_SUPPORT_FIRMA';

// alle Verträge des Kunden
export const SET_TESTPHASE = 'SET_TESTPHASE';
export const SET_VERTRAGE = 'SET_VERTRAGE';

// ----------------------------------------------------------------------------------------------------------------------------

export function enqueueSnackbar(notification) {
    const key = notification.options && notification.options.key;

    return {
        type: ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random(),
        },
    };
}

export function closeSnackbar(key) {
    return {
        type: CLOSE_SNACKBAR,
        dismissAll: !key, // dismiss all if no key has been defined
        key,
    };
}

export function removeSnackbar(key) {
    return {
        type: REMOVE_SNACKBAR,
        key,
    };
}

export function setAllVehiclesState(state: FluxStore['allVehiclesState']) {
    const allVehiclesState = undefined === state ? { suche: {}, sort: [] } : state;
    return {
        type: SET_ALLVEHICLESSTATE,
        allVehiclesState,
    };
}

export function setImageSettings(imageSet: FluxStore['imageSettings']) {
    const imageSettings = undefined === imageSet ? null : imageSet;
    return {
        type: SET_IMAGESETTINGS,
        imageSettings,
    };
}

export function setLastLeadListUpdate(ts: FluxStore['lastLeadListUpdate']) {
    const lastLeadListUpdate = undefined === ts ? null : ts;
    return {
        type: SET_LAST_LEAD_LIST_UPDATE,
        lastLeadListUpdate,
    };
}

// dn Leadstatus setzen
export function setLeadStatus(leadstatus: FluxStore['leadstatus']) {
    return {
        type: SET_LEADSTATUS,
        leadstatus,
    };
}

// die Fahrzeugliste setzen (fuer den Filter)
export function setUserSettings(userSettings: FluxStore['userSettings']) {
    return {
        type: SET_USER_SETTINGS,
        userSettings,
    };
}

export function setUpdateRequired(update: FluxStore['updateRequired']) {
    const state = undefined === update ? null : update;
    return {
        type: SET_UPDATE_REQUIRED,
        state,
    };
}

export function setLoginToken(loginTokenOrig: FluxStore['loginToken']) {
    const loginToken = undefined === loginTokenOrig ? null : loginTokenOrig;
    return {
        type: SET_LOGIN_TOKEN,
        loginToken,
    };
}

export function setTestphase(testphaseOrig: FluxStore['testphase']) {
    const testphase = undefined === testphaseOrig ? null : testphaseOrig;
    return {
        type: SET_TESTPHASE,
        testphase,
    };
}

export function setVertrage(vertrageOrig: FluxStore['vertrage']) {
    const vertrage = undefined === vertrageOrig ? null : vertrageOrig;
    return {
        type: SET_VERTRAGE,
        vertrage,
    };
}

export function setCarList(carListOrig: FluxStore['carList']) {
    const carList = undefined === carListOrig ? null : carListOrig;
    return {
        type: SET_CARLIST,
        carList,
    };
}

export function setCarListFilter(filterOrig: FluxStore['carListFilter']) {
    const carListFilter = !filterOrig ? null : filterOrig;
    return {
        type: SET_CARLIST_FILTER,
        carListFilter,
    };
}

export function setCarListFiltered(filterOrig: FluxStore['carListFiltered']) {
    const carListFiltered = !filterOrig ? null : filterOrig;
    return {
        type: SET_CARLIST_FILTERED,
        carListFiltered,
    };
}

export function setCarListSize(carListOrig: FluxStore['carListSize']) {
    const carListSize = undefined === carListOrig ? null : carListOrig;
    return {
        type: SET_CARLIST_SIZE,
        carListSize,
    };
}

export function setUnchangedData(bUnchangedData: FluxStore['unchangedData']) {
    const unchangedData = undefined === bUnchangedData ? false : bUnchangedData;
    return {
        type: SET_UNCHANGED_DATA,
        unchangedData,
    };
}

export function setCarsChanged(carsChangedArray: FluxStore['carsChanged']) {
    const carsChanged = undefined === carsChangedArray ? null : carsChangedArray;
    return {
        type: SET_CHANGED_CARS,
        carsChanged,
    };
}
